import styled from "styled-components";

export const DropdownContainer = styled.div`
  display: contents;

  #dropdown-button {
    color: inherit;
    background: inherit;
    border: 0;
    padding: 0;

    &:hover {
      background-color: transparent;
    }
  }

  .dropdown-menu {
    background: ${({ theme }) => theme.dropdown.bg.quaternary} !important;
    position: absolute;
    border: none;
    border-radius: 16px;

    .dropdown-item {
      color: ${({ theme }) => theme.global.extraInfo.font.color};
      text-align: center;
      display: flex;

      &:hover {
        color: ${({ theme }) => theme.global.color.bodyColor};
      }
      .icon {
        margin-right: 0.5rem;
      }
    }
  }

  .dropdown-toggle-split {
    border-radius: 12px !important;
    position: absolute !important;
    right: 0 !important;
  }

  .dropdown-toggle::after {
    display: none;
    &::after {
      display: inline-block;
    }
  }
  .dropdown-btn {
    text-align: start;
  }
`;

export const CustomDropdownContainer = styled.div`
  .floated-label {
    position: relative;

    label {
      position: absolute;
      top: -20px;
      left: 0px;
      padding: 0px 5px;
    }
  }
  .btn-select {
    min-width: 95px;
  }
  .popover {
    top: -5px !important;
    color: ${({ theme }) => theme.dropdown.bg.quaternary};
    border: 1px solid #ffffff;
    border-radius: 6px;

    .popover-header,
    .popover-body {
      background: #191b20;
      color: ${({ theme }) => theme.dropdown.bg.quaternary};
      border-radius: 6px;
    }

    .popover-arrow {
      display: none;
    }
  }

  .has-error {
    border: 1px solid lightcoral !important;
  }

  @media (max-width: 767px) {
    .floated-label label {
      top: -14px;
      font-size: 8px;
    }
  }
`;
export const DropdownWrapper = styled.div`
  margin-bottom: 1.5rem;
  position: relative;
  width: 100%;
  z-index: 1;
`;

export const DropdownLabel = styled.label`
  display: block;
  margin-bottom: 0.75rem;
  font-family: "Geist", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #181d27;
  line-height: 1.5;
`;

export const DropdownSelect = styled.select`
  width: 100%;
  padding: 16px 48px 16px 20px;
  border-radius: 8px;
  background-color: #ffffff;
  color: #1f2937;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  transition: all 0.2s ease-in-out;
  border: 1px solid var(--Colors-Border-border-primary, #d5d7da);
  box-shadow: 0 1px 2px 0
    var(--Colors-Effects-Shadows-shadow-xs, rgba(10, 13, 18, 0.05));

  /* ✅ remove browser styling */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  /* ✅ keep styles consistent */
  &:focus {
    outline: none;
    border: 2px solid #2563eb; /* Blue border on focus */
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  }

  &:hover {
    border-color: #2563eb; /* Blue border on hover */
    background-color: #ffffff;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: #f9fafb;
    border-color: #e5e7eb;
  }

  /* Style the options */
  option {
    padding: 12px 40px 12px 16px; /* Extra right padding for checkmark */
    font-size: 16px;
    color: #1f2937;
    background-color: #ffffff;
    border: none;
    position: relative;

    &:hover {
      background-color: #f3f4f6;
    }

    &:checked {
      background-color: #eff6ff; /* Light blue background for selected */
      color: #2563eb; /* Blue text for selected */
      font-weight: 500;

      /* Add checkmark for selected option */
      &::after {
        content: "✓";
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #2563eb;
        font-weight: 600;
      }
    }

    &:disabled {
      color: #9ca3af;
      background-color: #f9fafb;
    }
  }
`;

/* ✅ custom arrow */
export const DropdownArrow = styled.span`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: "";
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #6b7280;
    transition: transform 0.2s ease-in-out;
    transform: ${({ $isOpen }) =>
      $isOpen ? "rotate(180deg)" : "rotate(0deg)"};
  }

  /* Rotate arrow when dropdown is focused/active */
  select:focus + &::after {
    transform: rotate(180deg);
  }
`;

/* Custom Dropdown Styles */
export const NewCustomDropdownContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 0; /* Prevent layout shifts when dropdown opens */

  /* Ensure dropdown doesn't affect document flow */
  &::after {
    content: "";
    display: block;
    height: 0;
    clear: both;
  }
`;

export const CustomDropdownButton = styled.button`
  width: 100%;
  padding: 16px 48px 16px 20px;
  border-radius: 8px;
  background-color: #ffffff;
  color: #1f2937;
  font-family: "Geist", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--Colors-Border-border-primary, #d5d7da);
  box-shadow: 0 1px 2px 0
    var(--Colors-Effects-Shadows-shadow-xs, rgba(10, 13, 18, 0.05));

  &:hover {
    border-color: #2563eb; /* Blue border only on hover */
  }

  &:focus {
    outline: none;
    border: 2px solid #2563eb; /* Blue border only on focus */
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: #f9fafb;
    border-color: #e5e7eb;
  }

  .dropdown-text {
    flex: 1;
    color: ${({ $hasValue }) => ($hasValue ? "#1f2937" : "#9ca3af")};
  }
`;

export const CustomDropdownMenu = styled.div`
  position: absolute;
  ${({ $openUpward }) => ($openUpward ? "bottom: 100%;" : "top: 100%;")}
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  ${({ $openUpward }) =>
    $openUpward ? "margin-bottom: 4px;" : "margin-top: 4px;"}
  max-height: 300px;
  overflow-y: auto;
`;

export const CustomDropdownOption = styled.div`
  padding: 12px 16px;
  font-family: "Geist", sans-serif;
  font-size: 16px;
  color: #1f2937;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: #f3f4f6;
  }

  &:first-child {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  &:last-child {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  ${({ $isSelected }) =>
    $isSelected &&
    `
    background-color: #eff6ff;
    color: #2563eb;
    font-weight: 500;
    
    &:hover {
      background-color: #dbeafe;
    }
  `}

  .option-text {
    flex: 1;
  }

  .checkmark {
    color: #2563eb;
    font-weight: 600;
    margin-left: 8px;
  }
`;
